// Vlnena location
export const DEFAULT_LAT = 49.189;
export const DEFAULT_LNG = 16.617;
